export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    showLabTable({commit}) {
        commit('showLabTable');
    },
    showLabForm({commit}) {
        commit('showLabForm');
    },
    showPatientLabTable({commit}) {
        commit('showPatientLabTable');
    },
    showPatientLabForm({commit}) {
        commit('showPatientLabForm');
    },
}
